"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MeetingPlacardPageActions;
(function (MeetingPlacardPageActions) {
    MeetingPlacardPageActions["SettingsChanged"] = "SettingChanged";
    MeetingPlacardPageActions["MeetingLoading"] = "MeetingLoading";
    MeetingPlacardPageActions["MeetingLoaded"] = "MeetingLoaded";
})(MeetingPlacardPageActions || (MeetingPlacardPageActions = {}));
exports.default = MeetingPlacardPageActions;
